import JiraConnected from '../../../containers/source-integration/independent-integrations/jira'

export const jira = {
  component: JiraConnected,
  data: {
    title: 'Spectral Jira Scanner',
    tileKey: 'jira',
  },
}
